const ActionFormPanel = ({ color, title, description, children }) => (
    <div
        className="card p-3 mb-4"
        style={{
            backgroundColor: '#fff',
            border: `1px solid ${color}30`,
            borderLeft: `4px solid ${color}`,
            borderRadius: 10,
        }}
    >
        <span
            style={{
                display: 'block',
                fontWeight: 600,
                fontSize: '0.875rem',
                color: '#1a1a1a',
                marginBottom: 4,
            }}
        >
            {title}
        </span>
        <span
            style={{
                display: 'block',
                fontSize: '0.78rem',
                color: '#888',
                marginBottom: 16,
                lineHeight: 1.4,
            }}
        >
            {description}
        </span>
        {children}
    </div>
);

export default ActionFormPanel;
